
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken,onMessage,isSupported } from "firebase/messaging";
import { sendNotifInfo } from "./Api/ClientServices";


// import { setTokenForNotifAPI } from "./API/TaysuzServices";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
export const isItSupport = () =>
new Promise((resolve) => {
    isSupported((result) => {
    // console.log(payload)
    resolve(result);
  });
});

var firebaseConfig = {
  apiKey: "AIzaSyAI-6ra1K4W2O03bB_gFWqRZGmXVumc3Vw",

  authDomain: "barest-a5cb9.firebaseapp.com",

  projectId: "barest-a5cb9",

  storageBucket: "barest-a5cb9.appspot.com",

  messagingSenderId: "816973146919",

  appId: "1:816973146919:web:0d70f6fb9a55e398b29702",

  measurementId: "G-HCL7BJVG30"

};

// // Initialize Firebase
let messaging=null;
try{
  // console.log(isItSupport())
  if(isItSupport()){
    initializeApp(firebaseConfig);
    messaging = getMessaging();

  }
}catch(e){
}


export const getTokens = (setTokenFound) => {
  if(messaging!=null){
    return getToken(messaging,{vapidKey: 'BGxqtLZw2k4ipNB4-iSEGMWUO2tlCbTwlocGySqov__Gg73unFi8NmFXCq6F_1qLwleac4nH9v0hN4SMTVxrMqM'}).then((currentToken) => {
      if (currentToken) {
          if(localStorage.getItem('TokenNotifation')!==currentToken) {
            let info={
              token:currentToken,
              type:'admin'
            }
            sendNotifInfo(info,(succ)=>{
              if(succ.status===1){
                localStorage.setItem('TokenNotifation',currentToken)
                setTokenFound(true);
            }
            
            })
          }
        // Track the token -> client mapping, by sending to backend server
        // show on the UI that permission is secured
      } else {
        //console.log('No registration token available. Request permission to generate one.');
        setTokenFound(false);
        // shows on the UI that permission is required 
      }
    }).catch((err) => {
      console.log('An error occurred while retrieving token. ',err);
    });
  } 
  }
  export const onMessageListener = () =>
  new Promise((resolve) => {
    if(messaging!=null){
      onMessage(messaging,(payload) => {
      // console.log(payload)
      resolve(payload);
    });}
    
  });


